<template>
  <v-row no-gutters justify="center">
    <v-col cols="auto" class="text-center">
      <annotation-mode-button
        :image="coloredAssetUrls.cursor"
        :activeImage="activeAnnotationIcons.cursor"
        title="Select Annotation(s)"
        @click="$emit('input', annotationModes.Select)"
        :buttonMode="annotationModes.Select"
        :size="size"
        :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.erase"
        :activeImage="activeAnnotationIcons.erase"
        title="Delete Annotation(s)"
        @click="$emit('input', annotationModes.Delete)"
        :buttonMode="annotationModes.Delete"
        :size="size"
        :annotationMode="context.annotationMode"/>
      <annotation-mode-button
        :image="coloredAssetUrls.magnify"
        :activeImage="activeAnnotationIcons.magnify"
        title="Magnify"
        @click="$emit('input', annotationModes.Magnify)"
        :buttonMode="annotationModes.Magnify"
        :size="size"
        :annotationMode="context.annotationMode"/>
      <circle-image-button
        :active="isFlipped"
        :image="flipIcon"
        title="Indirect View (180°)"
        :size="size"
        btnClass="primary"
        @click="$emit('flip')"/>
      <circle-image-button
        :active="isFlipped90"
        :image="flip90Icon"
        title="90° Rotation"
        :size="size"
        btnClass="primary"
        @click="$emit('flip90')"/>
      <circle-image-button
        title="Fit Image in Window"
        :image="coloredAssetUrls.fitToWindow"
        :size="size"
        btnClass="primary"
        @click="$emit('fit')"/>
      <circle-slot-button
        title="Scale Image to Original Size"
        :size="size"
        :btnClass="'primary ' + colorClass"
        @click="$emit('zoom')">1:1</circle-slot-button>
    </v-col>
  </v-row>
</template>

<script>
import { ANNOTATION_MODES } from "../../../config/config";
import circleImageButton from "../../controls/CircleImageButton";
import annotationModeButton from "../../imageBrowser/controls/AnnotationModeButton";
import circleSlotButton from "../../controls/CircleSlotButton";

export default {
  name: "annotationControlButtonCollection",
  components: { circleImageButton, annotationModeButton, circleSlotButton },
  props: {
    context: Object,
    isFlipped: Boolean,
    isFlipped90: Boolean,
    size: { type: String, default: "small" }
  },
  data() {
    return {
      annotationModes: ANNOTATION_MODES
    };
  },
  computed: {
    flipIcon() {
      return this.isFlipped
        ? this.activeAnnotationIcons.oneEightyDegree
        : this.coloredAssetUrls.oneEightyDegree;
    },
    flip90Icon() {
      return this.isFlipped90
        ? this.activeAnnotationIcons.nintyDegree
        : this.coloredAssetUrls.nintyDegree;
    }
  },
  methods: {
    buttonClass(color) {
      let btnClass = "rounded-button annotation-color-button "  + this.colorClass;
      if (color === this.value) btnClass += " selected-color";
      return btnClass;
    }
  }
};
</script>
